export const daysOfWeek = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
